__turbopack_context__.v({
  "expertise": "AuthorInfo-module-scss-module__n0FiTq__expertise",
  "expertiseLink": "AuthorInfo-module-scss-module__n0FiTq__expertiseLink",
  "expertiseList": "AuthorInfo-module-scss-module__n0FiTq__expertiseList",
  "wrapper": "AuthorInfo-module-scss-module__n0FiTq__wrapper",
});
